<template>
	<transition name="fade">
		<div v-if="serviceModalOpen" class="modal" tabindex="-1" ref="waModal">
			<div class="modal-dialog modal-lg">
				<div class="modal-content px-2">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <h2>Would you like {{ service.name }} for only <b>&pound;{{ service.price_type == 'fixed' ? service.retail : parseFloat(service.retail * basket.total_tyres).toFixed(2) }}</b>?</h2>
                                <p v-html="service.long_description"></p>
                            </div>
                            <div class="col-6 text-end">
                                <button class="d-inline-block btn btn-secondary" @click="this.$parent.handleServiceUpsell()">No thanks</button>
                            </div>
                            <div class="col-6 text-start">
                                <button class="btn btn-primary d-inline-block green-bg" @click="this.$parent.handleServiceUpsell(service.code, (service.price_type === 'fixed' ? 1 : basket.total_tyres))">Yes please</button>
                            </div>
                        </div>
                    </div>
				</div>
			</div>
		</div>
	</transition>
</template>
<script>
    export default {
        props: ['service', 'service-modal-open', 'basket'],
        data() {
            return {
            }
        },
        mounted() {
        },
        methods: {

        },
        computed: {

        }
    }
</script>
<style lang="scss" scoped>
    .error {
        color: red;
    }
    .modal {
		background-color: rgba(0,0,0,.5);
	  	display: block;
	}
</style>